var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 26.503,
    viewBox: "0 0 29 26.503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2756",
    "data-name": "\\uADF8\\uB8F9 2756",
    transform: "translate(-2478 -15772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1687",
    "data-name": "\\uADF8\\uB8F9 1687",
    transform: "translate(2475 15772)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_53",
    "data-name": "\\uD0C0\\uC6D0 53",
    cx: 3.396,
    cy: 3.396,
    r: 3.396,
    transform: "translate(14.23 14.155)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_53_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD0C0\\uC6D0 53 - \\uC724\\uACFD\\uC120",
    d: "M3.4,0A3.4,3.4,0,1,1,0,3.4,3.4,3.4,0,0,1,3.4,0Z",
    transform: "translate(14.23 14.155)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uBE7C\\uAE30_4",
    "data-name": "\\uBE7C\\uAE30 4",
    d: "M10.6,13.348a9.993,9.993,0,0,1-4.025-.841,10.525,10.525,0,0,1-3.317-2.3A11.287,11.287,0,0,1,.965,6.783,11.781,11.781,0,0,1,.01,2.568H0V-6H2.139V2.66h.008A8.671,8.671,0,0,0,10.6,11.229,8.673,8.673,0,0,0,19.053,2.66h.007V-6H21.2V2.568H21.19a11.761,11.761,0,0,1-.954,4.216,11.274,11.274,0,0,1-2.293,3.424,10.533,10.533,0,0,1-3.317,2.3A10,10,0,0,1,10.6,13.348Z",
    transform: "translate(6.901 13.155)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uBE7C\\uAE30_4_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uBE7C\\uAE30 4 - \\uC724\\uACFD\\uC120",
    d: "M10.6,13.348a9.993,9.993,0,0,1-4.025-.841,10.525,10.525,0,0,1-3.317-2.3A11.287,11.287,0,0,1,.965,6.783,11.781,11.781,0,0,1,.01,2.568H0V-6H2.139L2.148,2.66A8.671,8.671,0,0,0,10.6,11.229,8.673,8.673,0,0,0,19.053,2.66h.007V-6H21.2V2.568h-.011a11.761,11.761,0,0,1-.954,4.216,11.274,11.274,0,0,1-2.293,3.424,10.533,10.533,0,0,1-3.317,2.3A10,10,0,0,1,10.6,13.348Z",
    transform: "translate(6.901 13.155)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1147",
    "data-name": "\\uC0AC\\uAC01\\uD615 1147",
    width: 29,
    height: 8.563,
    rx: 1,
    transform: "translate(3 0)",
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecorder);
export default __webpack_public_path__ + "static/media/recorder.81e731658194fc84e4064e0ac84768c5.svg";
export { ForwardRef as ReactComponent };